/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class AssessmentEditDialog extends Component {
  @service
  session;

  @service
  store;

  @tracked
  timeframes = null;

  @tracked
  assessmentGradeSchedule;

  @tracked
  isVisibleToLearners;

  @tracked
  assessmentDisplay;

  @action
  setAssessmentDisplay(value) {
    this.assessmentDisplay = value;
  }

  @tracked
  canLearnersEdit;

  @action
  setCanLearnersEdit(value) {
    this.canLearnersEdit = value;
  }

  @tracked
  description;

  @action
  setDescription(value) {
    this.description = value;
  }

  @tracked
  label;

  @action
  setLabel(value) {
    this.label = value;
  }

  @tracked
  noGradesColumnsToShowCaregiversStudents;

  @action
  setNoGradesColumnsToShowCaregiversStudents(value) {
    this.noGradesColumnsToShowCaregiversStudents = value;
  }

  @tracked
  noGradesColumnsToShowStaff;

  @action
  setNoGradesColumnsToShowStaff(value) {
    this.noGradesColumnsToShowStaff = value;
  }

  @tracked
  showHistoryToLearners;

  @action
  setShowHistoryToLearners(value) {
    this.showHistoryToLearners = value;
  }

  @tracked
  showToCaregiversOnlyIfContent;

  @action
  setShowToCaregiversOnlyIfContent(value) {
    this.showToCaregiversOnlyIfContent = value;
  }

  @tracked
  type;

  @action
  setType(value) {
    this.type = value;
  }

  init() {
    super.init(...arguments);
    let schoolId = this.get('session.activeSchool');
    this.store.query('timeframe', { schoolId }).then((timeframes) => {
      this.timeframes = timeframes;
    });
  }

  @action
  selectAssessmentGradeSchedule(schedule) {
    this.assessmentGradeSchedule = schedule;
  }

  @action
  toggleIsVisibleToLearners(isVisibleToLearners) {
    this.isVisibleToLearners = isVisibleToLearners;
    if (!isVisibleToLearners) {
      this.showHistoryToLearners = false;
      this.canLearnersEdit = false;
    }
  }
}
